module.exports = __webpack_public_path__ + "step2_child_to_parent_daughter.4c479d0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step2_child_to_parent_daughter.jpg
// module id = DGjy
// module chunks = 0